import { connect } from 'react-redux'
import { compose, withState } from 'recompose'

import {
  dataFetched,
  dataRemoved,
  extraDataFromResultAndDispatch,
  makesMutations,
} from 'data/graphql'
import { createErrorToasterMessage } from 'data/ui/actions'

import {
  createThread,
  addCommentToThread,
  resolveThread,
  unresolveThread,
  archiveComment,
  updateComment,
} from 'remote/threads'

export const providesCreateThread = compose(
  connect(
    null,
    {
      dataFetched,
      dataRemoved,
    }
  ),
  makesMutations({
    query: createThread,
    mutationPropName: 'createThread',
    getOnResultFromProps: extraDataFromResultAndDispatch('createThread'),
  })
)

export const providesCreateThreadWithStatus = compose(
  withState('createCommentStatus', 'setCreateCommentStatus', {
    ongoing: false,
    success: false,
    error: null,
  }),
  connect(
    null,
    {
      dataFetched,
      dataRemoved,
      createErrorToasterMessage,
    }
  ),
  makesMutations({
    query: createThread,
    mutationPropName: 'createThread',
    getOnQueryFromProps: ({ setCreateCommentStatus }) => () => {
      setCreateCommentStatus({ ongoing: true })
    },
    getOnResultFromProps: ({ dataFetched, setCreateCommentStatus }) => ({
      result,
      meta,
    }) => {
      setCreateCommentStatus({ ongoing: false, success: true })
      extraDataFromResultAndDispatch('createThread')({ dataFetched })({
        result,
        meta,
      })
    },
    getOnErrorFromProps: ({
      createErrorToasterMessage,
      setCreateCommentStatus,
    }) => ({ error }) => {
      setCreateCommentStatus({ error })
      createErrorToasterMessage({
        title: 'Failed to create thread. Check your network connection',
      })
    },
  })
)

export const providesAddCommentToThread = compose(
  withState('createCommentStatus', 'setCreateCommentStatus', {
    ongoing: false,
    success: false,
    error: null,
  }),
  connect(
    null,
    { dataFetched, createErrorToasterMessage }
  ),
  makesMutations({
    query: addCommentToThread,
    mutationPropName: 'addCommentToThread',
    getOnQueryFromProps: ({ setCreateCommentStatus }) => () => {
      setCreateCommentStatus({ ongoing: true })
    },
    getOnResultFromProps: ({ dataFetched, setCreateCommentStatus }) => ({
      result,
      meta,
    }) => {
      setCreateCommentStatus({ ongoing: false, success: true })
      extraDataFromResultAndDispatch('addCommentToThread')({ dataFetched })({
        result,
        meta,
      })
    },
    getOnErrorFromProps: ({
      createErrorToasterMessage,
      setCreateCommentStatus,
    }) => ({ error }) => {
      setCreateCommentStatus({ error })
      createErrorToasterMessage({
        title: 'Failed to post comment. Check your network connection',
      })
    },
  })
)

export const providesThreadResolutionControls = compose(
  connect(
    null,
    { dataFetched }
  ),
  makesMutations({
    query: resolveThread,
    mutationPropName: 'resolveThread',
    getOnResultFromProps: extraDataFromResultAndDispatch('resolveThread'),
  }),
  makesMutations({
    query: unresolveThread,
    mutationPropName: 'unresolveThread',
    getOnResultFromProps: extraDataFromResultAndDispatch('unresolveThread'),
  })
)

export const providesCommentEditionControls = compose(
  connect(
    null,
    { dataFetched, dataRemoved }
  ),

  makesMutations({
    query: archiveComment,
    mutationPropName: 'archiveComment',
    getOnResultFromProps: ({ dataRemoved }) => ({ result }) => {
      dataRemoved(result.data.archiveComment)
    },
  }),

  makesMutations({
    query: updateComment,
    mutationPropName: 'updateComment',
    getOnResultFromProps: extraDataFromResultAndDispatch('updateComment'),
  })
)
